
async function addLetThemChooseNavigations () {
    const navList = document.querySelectorAll('.navigation__tier-1'); 
    try {
      const response = await fetch(`${window.BE_URL}/orders/let-them-choose/${customerId}`, {
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
      });
      const result = await response.json();
      const hasOrder = result?.data?.hasOrder;
      if (hasOrder) {
        const ordersLink = document.createElement('li');
        ordersLink.className = 'navigation__item';
        ordersLink.innerHTML = `<a href="/pages/let-them-choose-orders?view=order-let-them-choose" class="navigation__link">Let Them Choose Orders</a>`;

        const recipientsLink = document.createElement('li');
        recipientsLink.className = 'navigation__item';
        recipientsLink.innerHTML = `<a href="/pages/recipient?view=recipient" class="navigation__link">Let Them Choose Recipients</a>`;

        navList.forEach((nav) => {
          nav.appendChild(ordersLink.cloneNode(true));
          nav.appendChild(recipientsLink.cloneNode(true));
        });
      }
    } catch (error) {
      console.error('Error fetching order data:', error);
    }
  };


  window.addEventListener("DOMContentLoaded", async () => {
    if(window.customerId) {
        addLetThemChooseNavigations()
      }
  })